import {useEffect, useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import {useBreakpoints} from '@/hooks/use-breakpoints';
import {ROUTES} from '@/routes/constants';
import {useAppStore} from '@/services/store';
import {Button, SideNavigation as UIKitSideNavigation} from '@/ui-kit';
import {
  AccountCardDetails,
  AccountMultiple,
  BookOpen,
  ChevronLeft,
  ChevronRight,
  DocumentText,
} from '@/ui-kit/icons';
import {getActiveModuleName} from '@/utils/get-active-module-name';
import {localStore} from '@/utils/storage';
import styles from './side-navigation.module.scss';

const SIDE_NAVIGATION_COLLAPSED = 'SIDE_NAVIGATION_COLLAPSED';
export const MENU_ITEMS = [
  {
    key: ROUTES.ROSTERS,
    icon: <DocumentText />,
    link: ROUTES.ROSTERS,
    as: Link,
    label: 'Rosters',
  },
  {
    key: ROUTES.AUTHORIZATIONS,
    icon: <AccountCardDetails />,
    link: ROUTES.AUTHORIZATIONS,
    as: Link,
    label: 'Authorizations',
  },
  {
    key: ROUTES.ENCOUNTERS,
    icon: <AccountMultiple />,
    link: ROUTES.ENCOUNTERS,
    as: Link,
    label: 'Encounters',
  },
  {
    key: ROUTES.PAYER_CONFIG,
    icon: <BookOpen />,
    link: ROUTES.PAYER_CONFIG,
    as: Link,
    label: 'Payer Configuration',
  },
  {
    key: ROUTES.FAXES,
    icon: <DocumentText />,
    link: ROUTES.FAXES,
    as: Link,
    label: 'Faxes',
  },
];

export const SideNavigation = () => {
  const [collapsed, setCollapsed] = useState(
    localStore.get(SIDE_NAVIGATION_COLLAPSED),
  );
  const {pathname} = useLocation();
  const setActiveModule = useAppStore((state) => state.setActiveModule);
  const activeModuleName = getActiveModuleName(pathname);
  const {breakpoints} = useBreakpoints();

  useEffect(() => {
    setActiveModule(activeModuleName);
  }, [setActiveModule, activeModuleName]);

  const toggleButtonOnClick = () => {
    setCollapsed(!collapsed);
    localStore.set(SIDE_NAVIGATION_COLLAPSED, !collapsed);
  };

  return (
    <UIKitSideNavigation
      className={styles.navigation}
      collapsed={collapsed || breakpoints.sm}
      menuItems={MENU_ITEMS}
      selectedKey={activeModuleName}
    >
      {!breakpoints.sm && (
        <Button
          data-testid="toggle-button"
          type="tertiary"
          className={styles.toggleButton}
          leftIcon={
            collapsed ? (
              <ChevronRight data-testid="expand-icon" />
            ) : (
              <ChevronLeft data-testid="collapse-icon" />
            )
          }
          onClick={toggleButtonOnClick}
        />
      )}
    </UIKitSideNavigation>
  );
};
